import React from 'react';
import { CalendarConfig } from '../types/Calendar';
import { getMoonPhases } from '../utils/calendarUtils';
import MoonPhaseIcon from './MoonPhaseIcon';
import './MoonBar.css';

interface MoonBarProps {
  config: CalendarConfig;
  year: number;
  month: number;
  day: number;
}

const getPhaseName = (phase: number, cycle: number): string => {
  const ratio = phase / cycle;
  if (ratio < 0.03 || ratio > 0.97) return 'Neumond';
  if (ratio < 0.22) return 'Zunehmende Sichel';
  if (ratio < 0.28) return 'Erstes Viertel';
  if (ratio < 0.47) return 'Zunehmend';
  if (ratio < 0.53) return 'Vollmond';
  if (ratio < 0.72) return 'Abnehmend';
  if (ratio < 0.78) return 'Letztes Viertel';
  return 'Abnehmende Sichel';
};

const MoonBar: React.FC<MoonBarProps> = ({ config, year, month, day }) => {
  const moonPhases = getMoonPhases(year, month, day, config);

  if (moonPhases.length === 0) return null;

  return (
    <div className="moon-bar">
      <span className="moon-bar-label">Monde (Tag {day})</span>
      <div className="moon-bar-items">
        {moonPhases.map((moon, idx) => (
          <div key={idx} className="moon-bar-item">
            <MoonPhaseIcon
              phase={moon.phase}
              cycle={moon.cycle}
              name={moon.name}
              size={24}
            />
            <div className="moon-bar-info">
              <span className="moon-bar-name">{moon.name}</span>
              <span className="moon-bar-phase">{getPhaseName(moon.phase, moon.cycle)}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MoonBar;
